import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { translate, Translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { reset, updateFirmware } from './device-truck-implement.reducer';
import { toast } from 'react-toastify';

export const DeviceTruckImplementUpdateMcdFirmware = (props: RouteComponentProps) => {
  const dispatch = useAppDispatch();

  const updateSuccess = useAppSelector(state => state.deviceTruckImplement.updateSuccess);
  const [error, setError] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    firmware: '',
    updateAll: null,
    serial: '',
  });

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
      dispatch(reset());
      toast.success(formData.updateAll ? 'Os equipamentos foram atualizados.' : 'O equipamento foi atualizado.');
    }
  }, [updateSuccess]);

  const handleInputChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
  };

  const handleRadioChange = event => {
    setFormData({ ...formData, updateAll: event.target.value === 'all' });
    setError(null);
  };

  const handleClose = () => {
    props.history.push('/device-truck-implement' + props.location.search);
  };

  const saveEntity = values => {
    if (formData.updateAll === null || formData.updateAll === undefined) {
      setError('Selecione uma opção');
      return;
    }

    const params = { firmware: formData.firmware, serial: formData.serial, updateAll: formData.updateAll };
    dispatch(updateFirmware(params));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="deviceTruckImplementMcdFirmware">
        <Translate contentKey="fleetSenseApp.deviceTruckImplement.updateMcdFirmware">Update MCD Firmware</Translate>
      </ModalHeader>
      <ValidatedForm onSubmit={saveEntity}>
        <ModalBody id="fleetSenseApp.deviceTruckImplement.buttonMcdFirmware">
          <ValidatedField
            label={translate('fleetSenseApp.deviceTruckImplement.firmware')}
            id="device-truck-implement-firmware"
            name="firmware"
            required
            data-cy="firmware"
            type="text"
            onChange={e => handleInputChange('firmware', e.target.value)}
          />

          <Label style={{ marginLeft: '20px' }} check>
            <Input type="radio" name="updateOption" value="all" checked={formData.updateAll === true} onChange={handleRadioChange} data-cy="updateAllOption" />
            <Translate contentKey="fleetSenseApp.deviceTruckImplement.updateAll">Update everything</Translate>
          </Label>

          <Label style={{ marginLeft: '20px' }} check>
            <Input type="radio" name="updateOption" value="one" checked={formData.updateAll === false} onChange={handleRadioChange} data-cy="updateOneOption" />
            <Translate contentKey="fleetSenseApp.deviceTruckImplement.updateOne">Update only one</Translate>
          </Label>
          {error && (
            <div className="text-danger" style={{ fontSize: '13px' }}>
              {error}
            </div>
          )}

          {formData.updateAll === false && (
            <ValidatedField
              label={translate('fleetSenseApp.deviceTruckImplement.serial')}
              id="device-truck-implement-serial"
              name="serial"
              required={formData.updateAll === false}
              data-cy="serial"
              type="text"
              onChange={e => handleInputChange('serial', e.target.value)}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={handleClose} id="cancel-save" data-cy="entityCreateCancelButton" replace color="secondary">
            <FontAwesomeIcon icon="arrow-left" />
            &nbsp;
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.back">Back</Translate>
            </span>
          </Button>
          &nbsp;
          <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit">
            <FontAwesomeIcon icon="save" />
            &nbsp;
            <Translate contentKey="entity.action.save">Save</Translate>
          </Button>
        </ModalFooter>
      </ValidatedForm>
    </Modal>
  );
};

export default DeviceTruckImplementUpdateMcdFirmware;
